import React, { useState, useEffect } from 'react';
import { useAuth } from '../../contexts/AuthContext';

const LOGIN_IMAGE = '/images/main-page.jpg';

const Login = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [isWide, setIsWide] = useState(
    typeof window !== 'undefined' ? window.innerWidth >= 768 : true
  );
  const { login } = useAuth();

  useEffect(() => {
    const onResize = () => setIsWide(window.innerWidth >= 768);
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      await login(username, password);
      // The AuthContext will handle the navigation
    } catch (err) {
      setError(err.message || 'Přihlášení se nezdařilo');
    } finally {
      setLoading(false);
    }
  };

  const inputStyle = {
    width: '100%',
    padding: '12px 14px',
    border: '1px solid #e0e0e0',
    borderRadius: '8px',
    fontSize: '1rem',
    color: '#1a1a1a',
    boxSizing: 'border-box',
    transition: 'border-color 0.2s ease',
  };

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      backgroundColor: '#f5f5f5',
    }}>
      {/* Levý obrázkový panel (skrytý na mobilu) */}
      {isWide && (
        <div style={{
          flex: '1 1 50%',
          position: 'relative',
          backgroundImage: `url(${LOGIN_IMAGE})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }}>
          <div style={{
            position: 'absolute',
            inset: 0,
            background: 'linear-gradient(to top, rgba(0,0,0,0.55), rgba(0,0,0,0.15))',
          }} />
          <div style={{
            position: 'absolute',
            bottom: '48px',
            left: '48px',
            right: '48px',
            color: 'white',
          }}>
            <h2 style={{
              fontSize: '1.8rem',
              fontWeight: '500',
              margin: '0 0 8px',
              lineHeight: 1.3,
            }}>
              Uč se anglicky každý den
            </h2>
          </div>
        </div>
      )}

      {/* Pravý panel s formulářem */}
      <div style={{
        flex: isWide ? '1 1 50%' : '1 1 100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '40px 20px',
      }}>
        <div style={{ width: '100%', maxWidth: '360px' }}>
          <h1 style={{
            fontSize: '2rem',
            fontWeight: '500',
            marginBottom: '8px',
            color: '#1a1a1a',
          }}>
            English Teacher
          </h1>
          <p style={{
            fontSize: '1rem',
            color: '#666',
            marginBottom: '32px',
          }}>
            Přihlaste se a pokračujte ve studiu
          </p>

          {error && (
            <div style={{
              color: '#dc2626',
              backgroundColor: '#fef2f2',
              border: '1px solid #fecaca',
              padding: '10px 14px',
              borderRadius: '8px',
              marginBottom: '20px',
              fontSize: '0.9rem',
            }}>
              {error}
            </div>
          )}

          <form onSubmit={handleSubmit}>
            <div style={{ marginBottom: '18px' }}>
              <label htmlFor="username" style={{
                display: 'block',
                marginBottom: '6px',
                fontSize: '0.9rem',
                fontWeight: '500',
                color: '#1a1a1a',
              }}>
                Uživatelské jméno
              </label>
              <input
                type="text"
                id="username"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                required
                minLength="3"
                maxLength="50"
                autoComplete="username"
                style={inputStyle}
                onFocus={(e) => { e.target.style.borderColor = '#1d4ed8'; }}
                onBlur={(e) => { e.target.style.borderColor = '#e0e0e0'; }}
              />
            </div>

            <div style={{ marginBottom: '24px' }}>
              <label htmlFor="password" style={{
                display: 'block',
                marginBottom: '6px',
                fontSize: '0.9rem',
                fontWeight: '500',
                color: '#1a1a1a',
              }}>
                Heslo
              </label>
              <input
                type="password"
                id="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                minLength="6"
                autoComplete="current-password"
                style={inputStyle}
                onFocus={(e) => { e.target.style.borderColor = '#1d4ed8'; }}
                onBlur={(e) => { e.target.style.borderColor = '#e0e0e0'; }}
              />
            </div>

            <button
              type="submit"
              disabled={loading}
              style={{
                width: '100%',
                padding: '12px 20px',
                backgroundColor: '#1d4ed8',
                color: 'white',
                border: 'none',
                borderRadius: '8px',
                fontSize: '1rem',
                fontWeight: '500',
                cursor: loading ? 'not-allowed' : 'pointer',
                opacity: loading ? 0.6 : 1,
                transition: 'background-color 0.2s ease',
              }}
              onMouseEnter={(e) => { if (!loading) e.currentTarget.style.backgroundColor = '#1e40af'; }}
              onMouseLeave={(e) => { if (!loading) e.currentTarget.style.backgroundColor = '#1d4ed8'; }}
            >
              {loading ? 'Přihlašuji…' : 'Přihlásit se'}
            </button>
          </form>

          <p style={{
            marginTop: '20px',
            fontSize: '0.9rem',
            color: '#999',
          }}>
            Nemáte účet? Kontaktujte administrátora.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Login;
